import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { SimFilterActionsComponent } from '@simOn/ui/filter-actions';
import { FilterCounterComponent } from '@simOn/ui/filter-counter';
import { SimButtonModule } from '@simOn/ui/sim-button';
import { SimCheckboxModule } from '@simOn/ui/sim-checkbox';
import { SimFormModule } from '@simOn/ui/sim-form-filed';
import { SimIconModule } from '@simOn/ui/sim-icon';
import { SimInputModule } from '@simOn/ui/sim-input';
import { OptionComponent } from './components/option/option.component';
import { MAT_SELECT_SCROLL_STRATEGY_PROVIDER, SelectComponent } from './components/select.component';
import { SelectSearchDirective } from './directives/select-search.directive';

@NgModule({
  declarations: [SelectComponent, OptionComponent],
  imports: [
    SelectSearchDirective,
    CommonModule,
    OverlayModule,
    ScrollingModule,
    FormsModule,
    ReactiveFormsModule,
    MatPseudoCheckboxModule,
    MatIconModule,
    SimCheckboxModule,
    SimIconModule,
    SimInputModule,
    SimFormModule,
    SimButtonModule,
    FilterCounterComponent,
    SimFilterActionsComponent
  ],
  exports: [OverlayModule, ScrollingModule, SelectComponent, OptionComponent, SelectSearchDirective],
  providers: [MAT_SELECT_SCROLL_STRATEGY_PROVIDER]
})
export class SimSelectModule {}
